import { render, staticRenderFns } from "./SubmitForm.vue?vue&type=template&id=db6b9db8&scoped=true&"
import script from "./SubmitForm.vue?vue&type=script&lang=js&"
export * from "./SubmitForm.vue?vue&type=script&lang=js&"
import style0 from "./SubmitForm.vue?vue&type=style&index=0&id=db6b9db8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6b9db8",
  null
  
)

export default component.exports